export class NotfLocalizedTextApi
{
    enUsText: string;
    frFrText: string;
}
